import React from 'react';

export const themed = (Component) =>
  function ThemedComponent(props) {
    const theme = {
      heroValueProps: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflow: 'hidden',
      },
    };

    return React.createElement(Component, { ...props, theme });
  };
